<template>
  <div class="owner-action-cell d-flex align-center" data-testid="owner-action-cell">
    <v-btn
      outlined
      small
      class="owner-action-cell__follow-up-btn text-capitalize"
      :class="{ 'owner-action-cell__follow-up-btn--spacer': !showFollowUp }"
      :loading="showFollowUp && followUpLoading"
      :disabled="!showFollowUp || !canEdit || followUpLoading"
      :tabindex="showFollowUp ? undefined : -1"
      :aria-hidden="!showFollowUp"
      data-testid="owner-action-cell__follow-up-btn"
      @click="showFollowUp && $emit('follow-up')"
    >
      Follow Up
    </v-btn>

    <span
      class="owner-action-cell__divider"
      :class="{ 'owner-action-cell__divider--spacer': !showFollowUp }"
      aria-hidden="true"
    />

    <v-tooltip bottom content-class="tooltip-bottom" open-delay="300">
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-switch
            class="owner-action-cell__toggle ma-0"
            dense
            inset
            hide-details
            :disabled="!canEdit || toggleLoading"
            :input-value="enabled"
            :data-testid="enabled ? 'owner-action-cell__toggle-enabled' : 'owner-action-cell__toggle-disabled'"
            @change="$emit('toggle-status', $event)"
          />
        </div>
      </template>
      <span>{{ enabled ? 'Disable owner' : 'Enable owner' }}</span>
    </v-tooltip>

    <v-menu
      v-if="canEdit || canDelete"
      offset-y
      left
      :close-on-content-click="true"
      content-class="owner-action-cell__more-menu-panel"
      z-index="10"
      data-testid="owner-action-cell__more-menu"
    >
      <template #activator="{ on, attrs }">
        <v-tooltip bottom content-class="tooltip-bottom" open-delay="300">
          <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
            <v-btn
              icon
              small
              class="owner-action-cell__more-btn"
              aria-label="More actions"
              :disabled="deleteLoading"
              :loading="deleteLoading"
              v-bind="{ ...attrs, ...tooltipAttrs }"
              v-on="{ ...on, ...tooltipOn }"
              data-testid="owner-action-cell__more-btn"
            >
              <img
                src="/img/icons/fbc-icons/MoreActionsIcon.svg"
                alt=""
                class="owner-action-cell__more-icon"
                width="16"
                height="16"
              />
            </v-btn>
          </template>
          <span>More actions</span>
        </v-tooltip>
      </template>

      <div class="owner-action-cell__more-menu" data-testid="owner-action-cell__more-menu-list">
        <button
          v-if="canEdit"
          type="button"
          class="owner-action-cell__more-item"
          data-testid="owner-action-cell__edit-btn"
          @click.stop="$emit('edit')"
        >
          <span class="owner-action-cell__more-icon-wrap">
            <img
              src="/img/icons/fbc-icons/CycleMenuEdit.svg"
              alt=""
              class="owner-action-cell__more-item-icon"
              width="16"
              height="16"
            />
          </span>
          <span class="owner-action-cell__more-label">Edit</span>
        </button>

        <button
          v-if="canEdit && showReassign"
          type="button"
          class="owner-action-cell__more-item"
          data-testid="owner-action-cell__reassign-btn"
          @click.stop="$emit('reassign')"
        >
          <span class="owner-action-cell__more-icon-wrap">
            <img
              src="/img/cycle-settings/user-switch.svg"
              alt=""
              class="owner-action-cell__more-item-icon"
            />
          </span>
          <span class="owner-action-cell__more-label">Re-Assign</span>
        </button>

        <!-- Delete button temporarily commented out
        <button
          v-if="canDelete"
          type="button"
          class="owner-action-cell__more-item"
          data-testid="owner-action-cell__delete-btn"
          @click.stop="$emit('delete')"
        >
          <span class="owner-action-cell__more-icon-wrap">
            <img
              src="/img/icons/fbc-icons/DeleteActions.svg"
              alt=""
              class="owner-action-cell__more-item-icon"
              width="16"
              height="16"
            />
          </span>
          <span class="owner-action-cell__more-label">Delete</span>
        </button>
        -->
      </div>
    </v-menu>
  </div>
</template>

<script>
import './OwnerActionCell.scss';

export default {
  name: 'OwnerActionCell',
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
    /** Show Follow Up when the owner has at least one total request. */
    showFollowUp: {
      type: Boolean,
      default: false,
    },
    /** Show Re-Assign when the owner has requests to move to another owner. */
    showReassign: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    followUpLoading: {
      type: Boolean,
      default: false,
    },
    toggleLoading: {
      type: Boolean,
      default: false,
    },
    deleteLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
